<!--<div class="login-text" style="margin-bottom: 8px">Reset</div>

<div *ngIf="!formInit || initStatus == 0">
  <span>Load data...</span>
</div>
<form
  *ngIf="formInit && initStatus == 1"
  [antiAutoComplete]="antiAutocomplete"
  #form="ngForm"
  novalidate
  (ngSubmit)="onSubmit(form)"
>
  <div class="grid mt-2">
    <div class="col">
      <div class="ui-inputgroup">
        <div
          class="ui-float-label login-float"
          [class.float-label]="!!Password"
          style="flex-grow: 1"
        >
          <input
            id="password"
            name="password"
            type="password"
            autocomplete="off"
            [(ngModel)]="userRequestPasswordInfo.password"
            required
            #password="ngModel"
            strongPassword="2"
            [validCharactersSettings]="validCharacter"
          />
          <label for="password"><span *ngIf="NewPassword">New</span> Password</label>
        </div>
      </div>
    </div>
  </div>
  <password-feedback
    [feedback]="password.errors?.strongPassword"
    [validCharactersSettings]="validCharacter"
  ></password-feedback>

  <div class="ui-g-12">
    <span class="md-inputfield">
      <input
        type="password"
        id="confirmPassword"
        name="confirmPassword"
        pInputText
        [ngModel]="userRequestPasswordInfo.confirmPassword"
        #confirmPassword="ngModel"
        autocomplete="new-password"
        required
        [match]="password.value"
      />
      <label>Confirm password</label>
    </span>
    <password-match
      [confirmPassword]="confirmPassword.value"
      [password]="password.value"
    ></password-match>
  </div>
  <div class="ui-g-12">
    <button
      pButton
      type="submit"
      class="secondary"
      [disabled]="form.invalid || confirmPassword.value != password.value || disableSubmitButton"
      label="Save"
    ></button>
    <button pButton type="button" label="Cancel" (click)="router.navigate(['/account'])"></button>
  </div>
</form>-->

<div class="login-text" style="margin-bottom: 8px">User Registration</div>

<div *ngIf="initStatus == 0">
  <span>Load data...</span>
</div>

<form *ngIf="initStatus != 0" (ngSubmit)="onSubmit(form)" #form="ngForm" novalidate>
  <div>
    <div class="grid mt-2">
      <div class="col">
        <div class="ui-inputgroup">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!Password"
            style="flex-grow: 1"
          >
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="off"
              [(ngModel)]="Password"
              required
              #password="ngModel"
              strongPassword="2"
              [validCharactersSettings]="validCharacter"
            />
            <label for="password"><span *ngIf="NewPassword">New</span> Password</label>
          </div>
        </div>
      </div>
    </div>
    <password-feedback
      [feedback]="password.errors?.strongPassword"
      [validCharactersSettings]="validCharacter"
    ></password-feedback>

    <div class="grid">
      <div class="col">
        <div class="ui-inputgroup">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!ConfirmPassword"
            style="flex-grow: 1"
          >
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              autocomplete="off"
              [(ngModel)]="ConfirmPassword"
              required
              [match]="password.value"
              #confirmPassword="ngModel"
            />
            <label>Confirm <span *ngIf="NewPassword">New</span> Password</label>
          </div>
        </div>
      </div>
    </div>
    <password-match
      [confirmPassword]="confirmPassword.value"
      [password]="password.value"
    ></password-match>
    <div class="ui-g-12 control-label">
      <div>
        <button
          pButton
          type="submit"
          class="secondary"
          [disabled]="
            form.invalid || confirmPassword.value != password.value || disableSubmitButton
          "
          label="Save"
        ></button>
      </div>
      <div>
        <button type="button" class="back-to-login-btn" (click)="router.navigate(['/account'])">
          <i class="fa fa-arrow-left" style="margin-right: 5px" aria-hidden="true"></i>Back to Login
        </button>
      </div>
    </div>
  </div>
</form>
